module.exports = __webpack_public_path__ + "img/puzzel1-3.f6eb6167.png";